/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./taskDetail.vue?vue&type=template&id=ba2b482c&"
import script from "./taskDetail.vue?vue&type=script&lang=js&"
export * from "./taskDetail.vue?vue&type=script&lang=js&"
import style0 from "./taskDetail.vue?vue&type=style&index=0&id=ba2b482c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports